<mat-dialog-actions class="justify-content-between">

  <h4 class="f-s-16 f-w-600 m-b-16">
    {{ formTitleKey | translate }} {{ 'ENTITY.DAY_REPORT' | translate }}
  </h4>
  <button mat-icon-button class="d-flex justify-content-center" (click)="closeDialog()">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-divider></mat-divider>

<mat-dialog-content>

  <div *ngIf="readOnly || mode === 'view'" class="readonly-note">
    {{ readOnly ? ('LABEL.DISCHARGED_READONLY' | translate) : ('LABEL.VIEW_LABEL' | translate) }}
  </div>

  <form class="report-form" [formGroup]="reportForm">
    <div class="form-actions" *ngIf="!isDialog">
      <h4 class="m-0">{{ formTitleKey | translate }} {{ 'ENTITY.DAY_REPORT' | translate }}</h4>
    </div>

    <div class="report-meta" *ngIf="readOnly || mode === 'view'">
      <div>
        <span>{{ 'LABEL.REPORT_DATE' | translate }}</span>
        <strong>{{ getReportDateDisplay() }}</strong>
      </div>
      <div>
        <span>{{ 'LABEL.REPORT_TIME' | translate }}</span>
        <strong>{{ getReportTimeDisplay() }}</strong>
      </div>
      <div>
        <span>{{ 'LABEL.DOCTOR' | translate }}</span>
        <strong>{{ getDoctorNameDisplay() }}</strong>
      </div>
    </div>

    <app-vital-details [patientDetails]="patientDetails" [opdDetails]="opdDetails" [ipdData]="ipdData"
      [doctorData]="doctorData" [readOnly]="readOnly || mode === 'view'" [isDialog]="isDialog"
      [initialVitals]="currentVitals" (vitalsChanged)="onVitalsChanged($event)">
    </app-vital-details>

    <div class="note-grid">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'LABEL.DAILY_NOTES' | translate }}</mat-label>
        <textarea matInput rows="3" formControlName="dailynotes" [readonly]="!canEdit"></textarea>
        <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openTemplatePopup(TemplateType.DailyNotes)"
          [matTooltip]="'ENTITY.TEMPLATE' | translate" *ngIf="canEdit">
          <i-tabler name="template" class="icon-18"></i-tabler>
        </a>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'LABEL.PLAN_ADVICE' | translate }}</mat-label>
        <textarea matInput rows="3" formControlName="plan" [readonly]="!canEdit"></textarea>
        <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openTemplatePopup(TemplateType.PlanAdvice)"
          [matTooltip]="'ENTITY.TEMPLATE' | translate" *ngIf="canEdit">
          <i-tabler name="template" class="icon-18"></i-tabler>
        </a>
      </mat-form-field>
    </div>

    <div class="prescription-card">
      <div class="card-header">
        <h3><i-tabler name="pill" class="icon-22"></i-tabler> {{ 'LABEL.MEDICINE_ORDERS' | translate }}</h3>
        <button *appHasRole="ROLE_GROUPS.Clinical; when: canAddTemplate" mat-stroked-button color="primary" (click)="onPrescriptionTemplate()">
          {{ 'BUTTON.BTN_ADD_TEMPLATE' | translate }}
        </button>
      </div>

      <div class="template-toolbar" *ngIf="canEdit">
        <mat-form-field appearance="outline" class="template-search hide-hint">
          <mat-label>{{ 'ENTITY.PRESCRIPTION_TEMPLATE' | translate }}</mat-label>
          <input matInput type="text" [formControl]="templateCtrl" [matAutocomplete]="templateAuto"
            placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }}">
          <mat-autocomplete #templateAuto="matAutocomplete" (optionSelected)="onTemplateSelected($event.option.value)"
            [displayWith]="displayTemplateName">
            <mat-option *ngFor="let template of filteredTemplates" [value]="template">
              {{ template.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="table-container" formArrayName="medicines">
        <app-pharmacy-availability [drugs]="listOfDrugs" [lookupFailed]="pharmacyLookupFailed"
          [showLookupNotice]="true" />
        <table class="modern-table">
          <thead>
            <tr>
              <th style="width: 25%;">{{ 'LABEL.DRUG_NAME' | translate }}</th>
              <th style="width: 15%;">{{ 'LABEL.DRUG_PATTERN' | translate }}</th>
              <th style="width: 15%;">{{ 'LABEL.DURATION' | translate }}</th>
              <th style="width: 20%;">{{ 'LABEL.MEAL_RELATION' | translate }}</th>
              <th style="width: 20%;">{{ 'LABEL.INSTRUCTION' | translate }}</th>
              <th style="width: 5%;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of medicines.controls; let i = index" [formGroupName]="i">
              <td>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="drugName" [matAutocomplete]="drugAuto" [readonly]="!canEdit"
                    (input)="onDrugNameInput(i)" (blur)="onMedicineRowComplete(i)">
                  <mat-autocomplete #drugAuto="matAutocomplete" [displayWith]="displayDrug"
                    (optionSelected)="onDrugSelected($event, i)">
                    <mat-option *ngFor="let drug of rowFilteredDrugs$[i] | async" [value]="drug">
                      {{ drug.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="row.get('drugName')?.hasError('requiredMedicineDrug')">
                    {{ 'LABEL.SELECT_DRUG_REQUIRED' | translate }}
                  </mat-error>
                  <app-pharmacy-availability matSuffix [drugId]="row.get('drugId')?.value" [drugs]="listOfDrugs" />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="dosePattern" appDosePattern [times]="4" [readonly]="!canEdit"
                    (suggestionsChange)="dosePatternSuggestions[i] = $event" [matAutocomplete]="doseAuto"
                    (blur)="onMedicineRowComplete(i)">
                  <mat-autocomplete #doseAuto="matAutocomplete">
                    <mat-option *ngFor="let suggestion of dosePatternSuggestions[i]" [value]="suggestion">
                      {{ suggestion }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="row.get('dosePattern')?.hasError('requiredMedicineDosePattern')">
                    {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                  </mat-error>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="duration" [readonly]="!canEdit" (input)="onDurationInput($event, i)"
                    [matAutocomplete]="durationAuto" (blur)="onMedicineRowComplete(i)">
                  <mat-autocomplete #durationAuto="matAutocomplete">
                    <mat-option *ngFor="let suggestion of durationSuggestions[i]" [value]="suggestion">
                      {{ suggestion }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="row.get('duration')?.hasError('requiredMedicineDuration')">
                    {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                  </mat-error>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select formControlName="mealRelation" (selectionChange)="onMedicineRowComplete(i)">
                    <mat-option *ngFor="let item of mealRelationList" [value]="item">{{ mealRelationData[item]
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput formControlName="instruction" [readonly]="!canEdit" (blur)="onMedicineRowComplete(i)">
                </mat-form-field>
              </td>
              <td class="text-center">
                <button type="button" mat-icon-button color="warn"
                  *ngIf="canEdit && medicines.length > 1 && !isLastMedicineRow(i)" (click)="removeMedicineRow(i)">
                  <i-tabler name="trash" class="icon-18"></i-tabler>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </form>
</mat-dialog-content>

<mat-divider *ngIf="isDialog"></mat-divider>
<mat-dialog-actions *ngIf="isDialog">
  <div class="row m-t-4 p-r-16">
    <div class="col-lg-8"></div>
    <div class="col-lg-4 d-flex justify-content-end">
      <button mat-stroked-button class="m-r-5" (click)="closeDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
        }}</button>
      <button mat-flat-button color="primary" class=" m-l-4" *ngIf="canEdit" (click)="onSave()">
        {{ 'BUTTON.BTN_SAVE' | translate }}</button>
    </div>
  </div>
</mat-dialog-actions>

<div class="save-bar" *ngIf="!isDialog">
  <button mat-stroked-button class="m-r-5" (click)="closeDialog()">{{ 'BUTTON.BTN_CLOSE' | translate }}</button>
  <button mat-flat-button color="primary" class="m-l-4" *ngIf="canEdit" (click)="onSave()">
    {{ 'BUTTON.BTN_SAVE' | translate }}</button>
</div>
